import React, { Component } from "react";
/*import Modal from 'react-responsive-modal';*/

export default class DefaultFileScreen extends Component {
  /*constructor(props) {
    super(props);
  }*/

  render() {
    return (
      <div className="defaultFileContainer">
        <div className="filterContainer">
          <div className="filterContent">
            <span className="filterHeader">
              <h3>Filter</h3>
            </span>
            <div className="inputContainer">
              <p>Allgemein</p>
              <input type="text" placeholder="Name" />
              <input type="text" placeholder="Debitorennummer" />
              <input type="text" placeholder="Vertragskonto | Vertrag" />
              <select>
                <option>Mandat</option>
              </select>
            </div>
            <div className="inputContainer">
              <p>Adresse</p>
              <input type="text" placeholder="Straße" />
              <input type="text" placeholder="Postleitzahl" />
              <input type="text" placeholder="Ort" />
              <select>
                <option>Land</option>
              </select>
            </div>
            <div className="inputContainer">
              <p>Intern</p>
              <select>
                <option>Status</option>
              </select>
              <select>
                <option>Bearbeitungszustand</option>
              </select>
              <select>
                <option>Bearbeiter</option>
              </select>
              <select>
                <option>Kundengruppe</option>
              </select>
            </div>
            <div className="inputContainer multiple">
              <p>Fristen</p>
              <select className="first">
                <option>Von Fälligkeitsdatum</option>
              </select>
              <select>
                <option>Bis Fälligkeitsdatum</option>
              </select>
              <select className="first">
                <option>Von Mahnlaufdatum</option>
              </select>
              <select>
                <option>Bis Mahnlaufdatum</option>
              </select>
              <select className="first">
                <option>Von Anlagedatum</option>
              </select>
              <select>
                <option>Bis Anlagedatum</option>
              </select>
            </div>
            <button className="filterButton">Filter</button>
          </div>
        </div>
        <div className="selectionFilterContainer">
          <div className="selectionFilterContainerContent">
            <div className="selectionFilter">
              <p>Alle Fälle</p>
              <p>51</p>
              <p>›</p>
            </div>
            <div className="selectionFilter red">
              <p>Kritische Fälle</p>
              <p>5</p>
              <p>›</p>
            </div>
            <div className="selectionFilter red">
              <p>Bonität Verschlechtert</p>
              <p>21</p>
              <p>›</p>
            </div>
            <div className="selectionFilter orange">
              <p>Auffällig</p>
              <p>5</p>
              <p>›</p>
            </div>
            <div className="selectionFilter orange">
              <p>Kontakt Unbeantwortet</p>
              <p>6</p>
              <p>›</p>
            </div>
            <div className="selectionFilter blue">
              <p>Weiterleiten Empfohlen</p>
              <p>1</p>
              <p>›</p>
            </div>
            <div className="selectionFilter blue">
              <p>Kontaktdaten Fehlerhaft</p>
              <p>3</p>
              <p>›</p>
            </div>
            <div className="selectionFilter green">
              <p>Fälle Geschloßen</p>
              <p>8</p>
              <p>›</p>
            </div>
            <div className="selectionFilter green">
              <p>Kontakt Hinzufügen</p>
              <p>2</p>
              <p>›</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/DefaultFileScreen.js